import { DetailsBooking, ListBooking } from 'types';
import type { SelfServiceAPI } from 'types';

export interface PendingScheduledPayment {
  deferredTo: string;
  total: SelfServiceAPI.Total;
  creditCardPaymentAllocation: {
    allocation: SelfServiceAPI.Total;
    paymentMethod: SelfServiceAPI.ScheduledPaymentAllocationPaymentMethod;
  };
}

type HasPendingScheduledPaymentFlag = {
  flags?: { hasPendingScheduledPayment?: boolean };
};

type HasPaymentSchedule = {
  paymentSchedule?: unknown;
};

export const getPendingScheduledPayment = (booking: DetailsBooking | ListBooking): PendingScheduledPayment | undefined => {
  const maybeBooking = booking as unknown as HasPendingScheduledPaymentFlag & HasPaymentSchedule;
  if (!maybeBooking.flags?.hasPendingScheduledPayment) {
    return undefined;
  }

  if (!Array.isArray(maybeBooking.paymentSchedule)) {
    return undefined;
  }

  const upcomingScheduledPayment = (maybeBooking.paymentSchedule as unknown[]).find(
    (paymentSchedule): paymentSchedule is SelfServiceAPI.ScheduledPayment => {
      if (typeof paymentSchedule !== 'object' || paymentSchedule === null) return false;

      const attempts = (paymentSchedule as { attempts?: unknown }).attempts;
      if (!Array.isArray(attempts)) return false;

      return attempts.some((attempt) => (attempt as { status?: unknown }).status === 'PENDING');
    },
  );

  if (!upcomingScheduledPayment) {
    return undefined;
  }

  const upcomingPendingPaymentAttempt = upcomingScheduledPayment.attempts.find((attempt) => attempt.status === 'PENDING');
  const creditCardPaymentAllocation = upcomingPendingPaymentAttempt?.paymentAllocations?.find(
    (allocation) => allocation.paymentMethod.method === 'credit_card',
  );

  if (!creditCardPaymentAllocation) {
    return undefined;
  }

  return {
    deferredTo: upcomingScheduledPayment.deferredTo,
    total: upcomingScheduledPayment.total,
    creditCardPaymentAllocation: {
      allocation: creditCardPaymentAllocation.allocation,
      paymentMethod: creditCardPaymentAllocation.paymentMethod,
    },
  };
};
